module.exports = __webpack_public_path__ + "media/images/yellow_light-7b20b75cfd785827d329dda2d0e277c4.jpg";